// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    },
};

// Reszie Suggestion Box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    // Set Width for Suggestion box when opening
    // By default, the width of Suggestion box is equal to the Search box
    var width = searchElement.outerWidth();
    suggestionElement.outerWidth(width);
  
    if (jQ('.fancybox-overlay').length > 0) {
        jQ(suggestionElement).css({
            'position': 'fixed',
            'overflow-y': 'scroll',
            'height': '100px'
        });
    }
};

BCSfFilter.prototype.afterBuildSearchBox = function(id) {
    if (jQ(id).closest('form').length > 0){
      var submitButton = jQ(id).closest('form').find('[type="submit"]');
      if (submitButton && submitButton.length > 0){
        submitButton.each(function(index, button){
          button.setAttribute('name', 'bc-search-button');                
        });
      }
    }
  };